import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export default function CheckoutPost() {
  const location = useLocation();
  const navigate = useNavigate();
  const formRef = useRef<HTMLDivElement>(null);

  // 接收從 page.tsx 傳遞過來的 payUrl 與 params
  const { payUrl, params } = (location.state as any) || {};

  useEffect(() => {
    // 防止使用者右鍵 (對應您原生 HTML 的 oncontextmenu="return false;")
    const disableContextMenu = (e: MouseEvent) => e.preventDefault();
    document.addEventListener('contextmenu', disableContextMenu);

    if (payUrl && params) {
      // 找出造成 Content-Length 多 1 byte 的元兇！強制過濾所有的空白與隱形換行
      let inputsHtml = '';
      
      // 確保依照順序走訪 (金流有時會嚴格要求參數順序)
      Object.entries(params).forEach(([key, value]) => {
        const cleanKey = String(key).trim();
        const cleanValue = String(value).trim(); // 絕對關鍵：濾除尾部可能隱藏的 \n 或空白
        inputsHtml += `<input type='hidden' name='${cleanKey}' value='${cleanValue}' />\n`;
      });

      // 為了避免 React Virtual DOM 產生額外的封包編碼，我們使用最原始的 innerHTML
      // 這樣能 100% 確保渲染出來的結果與您提供的原生 HTML 結構完全一致
      if (formRef.current) {
        formRef.current.innerHTML = `
          <form action='${payUrl}' method='post' name='payform'>
            ${inputsHtml}
          </form>
        `;

        // 模擬原生 HTML 的 script 自動送出 (稍微延遲讓 DOM 確實掛載)
        setTimeout(() => {
          const form = document.forms.namedItem('payform');
          if (form) form.submit();
        }, 300);
      }
    } else {
      // 若無參數則回首頁
      navigate('/');
    }

    return () => {
      document.removeEventListener('contextmenu', disableContextMenu);
    };
  }, [payUrl, params, navigate]);

  return (
    <div 
      className="flex flex-col items-center justify-center min-h-[60vh]"
    >
      {/* 過場動畫提示 */}
      <div className="text-center">
        <i className="ri-loader-4-line text-5xl text-accent-orange animate-spin mb-4 block"></i>
        <h2 className="text-xl font-bold text-text-dark mb-2">安全連線中</h2>
        <p className="text-text-muted text-sm">正在為您導向銀行授權頁面，請勿關閉視窗...</p>
      </div>

      {/* 隱藏的原生表單容器，交給原生 JS 寫入 HTML */}
      <div ref={formRef} style={{ display: 'none' }}></div>
    </div>
  );
}